import api from '../lib/api';

const settingsService = {
  changePassword: (currentPassword, newPassword) =>
    api.post('/settings/change-password', { currentPassword, newPassword }),
};

export default settingsService;
